export const PRIVILEGE_DISPLAY_MAP: Record<string, string> = {
	// Screening Module - Batches
	GET_BATCHES: 'View Batches',
	CREATE_BATCH: 'Create Batch',
	UPDATE_BATCH: 'Update Batch',
	GET_ELIGIBLE_CANDIDATES_FOR_NEXT_BATCH: 'View Eligible Candidates',
	GET_APPLICATIONS: 'View Applications',

	// Screening Module - Registered Candidates
	GET_APPLICATION: 'Evaluate Application',

	// Screening Module - Proposer Load
	GET_PROPOSER_LOAD_SUMMARY: 'View Proposer Load',
	GET_ZONES_PROPOSER_LOAD_SUMMARY: 'View Zones Proposer Load',
	GET_CANDIDATES_LOAD_SUMMARY: 'View Candidate Load',
	BULK_ASSIGN_FUNCTIONARY_TO_APPLICATION_FOR_REGION: 'Bulk assign for region',

	// Screening Module - Screening Dashboard
	GET_CANDIDATE_SCREENING_PROGRESS_SUMMARY: 'View Screening Dashboard',
	REASSIGN_FUNCTIONARY_TO_APPLICATION: 'Proposer Reassign',
	UPDATE_REGION_ZONE_CENTER_OF_APPLICATION:
		'Update Region/Zone/Center of Application',

	// Screening Module - Central Team Dashboard
	GET_CENTRAL_TEAM_DASHBOARD_DETAIL: 'View Central Team Dashboard',

	// Screening Module - Pre-work Flow
	GET_PREWORK_APPLICATIONS: 'View Pre-work Applications',
	CAPTURE_PREWORK_MENTOR_ANSWERS: 'Review Pre-work Application',

	// Exam Module - Dashboard
	GET_EXAMINATION_GRAPHICAL_VIEW: 'View Registration Graph',
	GET_EXAM_RESULT_GRAPHICAL_VIEW: 'View Results Graph',

	// Exam Module - Exams
	CREATE_EXAM: 'Create Exam',
	UPDATE_EXAM: 'Update Exam',
	IMPORT_ELIGIBLE_CANDIDATES_FOR_EXAM: 'Upload Eligible Candidates',
	SEND_EXAM_REGISTRATION_INVITE_EMAIL: 'Send Invite Email',
	SEND_EXAM_ADMIT_CARD_EMAIL: 'Send Admit Card Email',
	SEND_EXAM_RESULT_EMAIL: 'Send Results Email',
	DOWNLOAD_CANDIDATE_EXAMINATION_DETAILS: 'Registration Data-Export Candidates',
	UPLOAD_EXAM_RESULTS: 'Results Upload',
	PLACE_CANDIDATE_ON_HOLD: 'Registration Data-Hold Candidate',
	CHANGE_EXAMINATION_CENTER: 'Registration Data-Edit Candidate',
	APPROVE_HELD_CANDIDATE: 'Approve Hold Candidate',

	// Exam Module - Centers
	CREATE_EXAMINATION_CENTER: 'Create Examination Center',
	UPDATE_EXAMINATION_CENTER: 'Update Examination Center',

	// Exam Module - Kanha Invite
	CREATE_KANHA_BATCH: 'Create Kanha Batch',
	UPDATE_KANHA_BATCH: 'Update Kanha Batch',
	IMPORT_ELIGIBLE_CANDIDATES_FOR_KANHA_BATCH:
		'Kanha Invite-Upload Eligible Candidates',
	SEND_KANHA_BATCH_INVITE_EMAIL: 'Kanha Invite-Send Invite Email',
	DOWNLOAD_KANHA_BATCH_CANDIDATE_DETAILS:
		'Kanha Invite-Download Candidate Details',
	UPLOAD_KANHA_BATCH_RESULTS: 'Kanha Invite-Upload Results',

	// NPS Module - Group Creation
	GET_PRECEPTORS: 'View New Preceptors List',
	CREATE_PRECEPTOR_GROUP: 'Create Preceptor Group',

	// NPS Module - Groups List
	GET_PRECEPTOR_GROUPS: 'View NPS Groups',
	UPDATE_PRECEPTOR_GROUP: 'Update Preceptor Group',
	DELETE_PRECEPTOR_GROUPS: 'Delete Preceptor Group',
	ASSIGN_MENTOR: 'Assign Mentor',

	// NPS Module - View All New Preceptors
	GET_PRECEPTOR_DASHBOARD_CARD_DETAIL: 'View All New Preceptors List',

	// NPS Module - Graphical View
	GET_GRAPHICAL_VIEW: 'View Graphical View',

	// NPS Module - NPS Batches
	GET_PRECEPTOR_BATCHES: 'View NPS Batches',
	CREATE_PRECEPTOR_BATCH: 'Create NPS Batch',
	UPDATE_PRECEPTOR_BATCH: 'Update NPS Batch',
	LOAD_PRECEPTORS_FROM_MYSRCM: 'Load Candidates',

	// Pre-work Module - Group Creation
	GET_PREWORK_CANDIDATES: 'View Pre-work Candidates List',
	CREATE_PREWORK_GROUP: 'Create Pre-work Group',

	// Pre-work Module - Groups List
	GET_PREWORK_GROUPS: 'View Pre-work Groups',
	UPDATE_PREWORK_GROUP: 'Update Pre-work Group',
	ASSIGN_PREWORK_MENTOR: 'Assign Pre-work Mentor',

	// Pre-work Module - View All Candidates
	GET_PREWORK_DASHBOARD_METRICS: 'View All Candidates List',

	// Pre-work Module - Graphical View
	GET_PREWORK_GRAPHICAL_VIEW: 'View Pre-work Graphical View',

	//Functionaries Module
	DOWNLOAD_TEMPLATE_FOR_BULK_UPLOAD_FUNCTIONARIES: 'Download Template',
	CREATE_OR_UPDATE_POSITION_ASSIGNMENT: 'Add or Update Functionaries',
	BULK_UPLOAD_FUNCTIONARIES: 'Bulk Upload',
	GET_FUNCTIONARY: 'View Functionaries',
	GET_ALL_PREDEFINED_REASONS: 'Predefined Reasons',
	REGISTER_FUNCTIONARY: 'Register Functionary',
	GET_SIGNED_URL: 'Signed URL',
};
